import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import XtpCreate from './containers/XtpCreate';
import XtpEdit from './containers/XtpEdit';
import XtpView from './containers/XtpView';
import { SYSTEM_CONFIGURATION_ROUTE, XTP, NETWORK } from '../../constants';

interface Props {
}

const Xtp: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP}`}>
        <XtpCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP}/view`}>
        <XtpView />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP}/edit`}>
        <XtpEdit />
      </Route>
    </Fragment>
  );
};

export default Xtp;
